import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  CostAddRequest,
  CostAddResponse,
  CostUpdateRequest,
  CostUpdateResponse,
  ExpenseAddRequest,
  ExpenseAddResponse,
  ExpenseCategoryAddRequest,
  ExpenseCategoryAddResponse,
  ExpenseCategoryUpdateActiveRequest,
  ExpenseCategoryUpdateRequest,
  ExpenseCategoryUpdateResponse,
  ExpenseDetailResponse,
  ExpenseListRequest,
  ExpenseUpdateRequest,
  ExpenseUpdateResponse,
} from "./Expense.constants";

export const useExpenseCategoryAddMutation = (): UseMutationResult<
  ExpenseCategoryAddResponse,
  AxiosError,
  ExpenseCategoryAddRequest
> =>
  useMutation<
    ExpenseCategoryAddResponse,
    AxiosError,
    ExpenseCategoryAddRequest
  >(async (requestValues: ExpenseCategoryAddRequest) => {
    const { data, status } = await axiosInstance.post(
      "cost/category/",
      requestValues
    );
    data.status = status;

    return data;
  });

export const useExpenseCategoryUpdateMutation = (): UseMutationResult<
  ExpenseCategoryUpdateResponse,
  AxiosError,
  ExpenseCategoryUpdateRequest
> =>
  useMutation<
    ExpenseCategoryUpdateResponse,
    AxiosError,
    ExpenseCategoryUpdateRequest
  >(async (requestValues: ExpenseCategoryUpdateRequest) => {
    const { data, status } = await axiosInstance.put(
      "cost/category/" + requestValues.id + "/",
      requestValues
    );
    data.status = status;

    return data;
  });

export const useExpenseCategoryUpdateActiveMutation = (): UseMutationResult<
  ExpenseCategoryUpdateResponse,
  AxiosError,
  ExpenseCategoryUpdateActiveRequest
> =>
  useMutation<
    ExpenseCategoryUpdateResponse,
    AxiosError,
    ExpenseCategoryUpdateActiveRequest
  >(async (requestValues: ExpenseCategoryUpdateActiveRequest) => {
    const { data, status } = await axiosInstance.put(
      "cost/category/" + requestValues.id + "/",
      requestValues
    );
    data.status = status;

    return data;
  });

export const useExpenseCategoryDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "cost/category/" + requestValues + "/"
    );

    return status;
  });

export const useExpenseCategoryListMutation = (): UseMutationResult<
  ExpenseCategoryAddResponse,
  AxiosError,
  any
> =>
  useMutation<ExpenseCategoryAddResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("cost/category/");

    return data;
  });
export const useExpenseAddMutation = (): UseMutationResult<
  ExpenseAddResponse,
  AxiosError,
  ExpenseAddRequest
> =>
  useMutation<ExpenseAddResponse, AxiosError, ExpenseAddRequest>(
    async (requestValues: ExpenseAddRequest) => {
      const { data, status } = await axiosInstance.post(
        "cost/category/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useExpenseUpdateMutation = (): UseMutationResult<
  ExpenseUpdateResponse,
  AxiosError,
  ExpenseUpdateRequest
> =>
  useMutation<ExpenseUpdateResponse, AxiosError, ExpenseUpdateRequest>(
    async (requestValues: ExpenseUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "cost/category/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useExpenseListMutation = (): UseMutationResult<
  ExpenseAddResponse,
  AxiosError,
  ExpenseListRequest
> =>
  useMutation<ExpenseAddResponse, AxiosError, ExpenseListRequest>(
    async (requestValues) => {
      const { data, status } = await axiosInstance.get(
        "cost/category/" + requestValues.id + "/sub/"
      );

      return data;
    }
  );

export const useExpenseDetailListMutation = (): UseMutationResult<
  ExpenseDetailResponse,
  AxiosError,
  ExpenseListRequest
> =>
  useMutation<ExpenseDetailResponse, AxiosError, ExpenseListRequest>(
    async (requestValues) => {
      const { data, status } = await axiosInstance.get(
        "cost/" + requestValues.id + "/by-category/"
      );

      return data;
    }
  );

// cost urls

export const useCostAddMutation = (): UseMutationResult<
  CostAddResponse,
  AxiosError,
  CostAddRequest
> =>
  useMutation<CostAddResponse, AxiosError, CostAddRequest>(
    async (requestValues: CostAddRequest) => {
      const { data, status } = await axiosInstance.post("cost/", requestValues);
      data.status = status;

      return data;
    }
  );

export const useCostUpdateMutation = (): UseMutationResult<
  CostUpdateResponse,
  AxiosError,
  CostUpdateRequest
> =>
  useMutation<CostUpdateResponse, AxiosError, CostUpdateRequest>(
    async (requestValues: CostUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "cost/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useCostDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  CostUpdateRequest
> =>
  useMutation<any, AxiosError, CostUpdateRequest>(
    async (requestValues: CostUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "cost/" + requestValues.id + "/",
        requestValues
      );

      data.status = status;

      return data;
    }
  );
